import React from 'react';
import { translations } from 'i18n';

import { useChromeExtensionPopup } from 'ChromeExtensionPopup/hooks/ChromeExtensionPopupHook';

import LegacyButton from '../LegacyButton';
import logoImage from 'images/popup/i-video-watcher-logo.png';
import videoWatcher2Img from 'images/sidebar/video-watcher-2.png';
import styles from './style.module.scss';

export const PauseButton = ({ showButton = true }) => {
  const { isPaused, setPaused, extensionsVersions, devices } = useChromeExtensionPopup();

  const hasOldExtension = extensionsVersions.some((v) => v.startsWith('1.'));
  return (
    <div className={styles.containerHeader}>
      <div className={styles.headerInfo}>
        <img
          className={styles.logoImage}
          src={hasOldExtension ? logoImage : videoWatcher2Img}
          alt="Logo"
        />
        <div className={styles.title}>
          <p className={styles.logoText}>Video Watcher {!hasOldExtension && '2'}</p>
          <p className={styles.logoSubText}>
            {translations('ExtensionPopup.Version')}: {extensionsVersions?.join(', ')}
          </p>
          {extensionsVersions?.length === 2 && (
            <p className={styles.warningText}>
              {translations('ChromeExtensionModal.RemoveOldExtension')}
            </p>
          )}
        </div>
      </div>
      {showButton && (
        <LegacyButton
          styles={styles.btn}
          disabled={!devices?.length}
          onClick={() => {
            setPaused((prev) => !prev);
          }}
          text={
            isPaused
              ? translations('ExtensionPopup.PlayDevice')
              : translations('ExtensionPopup.PauseDevice')
          }
        />
      )}
    </div>
  );
};
